const FLASH_TTL_MS = 3000

const flashStack = () => document.querySelector("[data-backoffice-flash-stack]")

const dismissFlash = (el) => {
  if (!el || el.dataset.dismissing === "true") return
  el.dataset.dismissing = "true"
  el.classList.add("is-hiding")
  setTimeout(() => el.remove(), 260)
}

export const showBackofficeFlash = (message, type = "notice") => {
  const stack = flashStack()
  if (!stack || !message) return

  const kind = type === "alert" ? "alert" : "notice"
  const existing = stack.querySelector("[data-backoffice-flash]")
  if (
    existing &&
    existing.dataset.dismissing !== "true" &&
    existing.textContent === message &&
    existing.classList.contains(`backoffice-flash--${kind}`)
  ) {
    clearTimeout(existing._flashTimer)
    existing._flashTimer = setTimeout(() => dismissFlash(existing), FLASH_TTL_MS)
    return
  }

  stack.querySelectorAll("[data-backoffice-flash]").forEach((el) => el.remove())

  const el = document.createElement("div")
  el.className = `backoffice-flash backoffice-flash--${kind}`
  el.dataset.backofficeFlash = "true"
  el.textContent = message
  stack.appendChild(el)

  el._flashTimer = setTimeout(() => dismissFlash(el), FLASH_TTL_MS)
}

export const initBackofficeFlashes = () => {
  const pending = sessionStorage.getItem("backofficeFlash")
  if (pending) {
    sessionStorage.removeItem("backofficeFlash")
    showBackofficeFlash(pending, "notice")
  }

  document.querySelectorAll("[data-backoffice-flash]").forEach((el) => {
    setTimeout(() => dismissFlash(el), FLASH_TTL_MS)
  })
}
